<template>
  <div
    style="width: 20rem"
    class="relative mv3"
  >
    <div
      class="bg-white pa3 br2 flex items-center justify-between near-black ba b--near-black"
      @click="toggleDropdown"
    >
      <div class="flex pr4">
        <simple-svg
          :filepath="icon"
          class="dib v-mid mr3 w1 h1 near-black"
        />
        <div
          class="ttc b"
          :class="{ 'b': dropdown }"
          v-html="title"
        />
      </div>
      <simple-svg
        :filepath="chevronDown"
        class="dib v-mid w1 h1"
        style="transition: all .35s ease"
        :class="{ 'rotate-180': dropdown }"
      />
    </div>
    <div
      class="absolute left-0 right-0 bg-white z-5 bb bl br b--near-black br2 br--bottom overflow-y-auto shadow-5"
      style="top: 95%; max-height: 31vh"
      v-if="dropdown && items.length > 0"
    >
      <div
        v-for="(item, index) in items"
        :key="index"
        @click="select(item)"
        class="ph3 pv3"
        :class="{'b mb2': item.area}"
        v-html="getHtmlContent(item)"
      />
    </div>
  </div>
</template>

<script>
const find = require('lodash/find')
export default {
  name: 'FilterDropdown',
  props: {
    title: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    items: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      dropdown: false,
      chevronDown: require('@/assets/img/chevron-down.svg'),
      selected: null
    }
  },
  computed: {
    activeFilters () {
      return this.$store.state.siteplan.filters
    },
    label () {
      if (this.selected) {
        return this.selected
      } else {
        return this.title
      }
    },
    checkOpenFilter () {
      return this.$store.state.openFilter
    }
  },
  watch: {
    checkOpenFilter (newValue, oldValue) {
      if (newValue !== this.title && this.dropdown === true) {
        this.dropdown = !this.dropdown
      }
    }
  },
  methods: {
    getHtmlContent (item) {
      if (this.title === 'Regions') {
        return item.title
      } else {
        return item
      }
    },
    select (item) {
      if (this.title === 'Regions') {
        this.active = false

        let markersCopy = this.$store.state.markers.slice()
        let foundDevelopment = find(markersCopy, function (o) { return o.title === item.title })

        this.$emit('select', {
          lat: parseFloat(item.location.lat),
          lng: parseFloat(item.location.lng),
          title: item.title,
          distance: foundDevelopment.distance
        })
        this.selected = item
        // this.$emit('set-filter', item.title)
        this.toggleDropdown()
      } else {
        this.selected = item
        this.$emit('set-filter', item)
        this.toggleDropdown()
      }
    },
    toggleDropdown () {
      this.dropdown = !this.dropdown
    }
  }
}
</script>
